import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import Scene from '../3D/Scene';

export default class Legal extends Default {
  id;
  isWrapAutoRemove = true;

  // Init per una pàgina Legal: el mar ha de quedar directament als settings FINALS (sense l'entrada
  // animada de la Home). No 1r cop → hereta el hide del canvas de Default.
  _sceneBeforeShow() {
    super._sceneBeforeShow();
    if (this.isFirstTime) Scene.directShowSea();
  }

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor() {
    super();

    document.body.classList.add("body-legal");
  }

  afterHide() {
    document.body.classList.remove("body-legal");

    super.afterHide();
  }
}

ControllerPage._addPage("legal", Legal)
